export default __webpack_public_path__ + "static/media/home-activities-afterparty.fb919e0d.png";